import { useState, useEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  TextField,
  FormHelperText,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { styled } from "@mui/system";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";

// InterFace
import { LIST_POST } from "../../config/const";
import { useWindowSize } from "../../lib/useWindowSize";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../../lib/store";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};
function SerchTextField({
  width,
  label,
  helperText,
  value,
  setValue,
  dataKey,
  addData,
}: {
  width: string;
  label: string;
  helperText: string;
  value: string;
  setValue: (value: string) => void;
  dataKey: string;
  addData: { [key: string]: string | boolean | any[] };
}) {
  const textFieldMargin = "10px 5px ";
  return (
    <Box>
      <Box className="serch-label">{label}</Box>
      <CustomTextField
        disabled={
          dataKey === "sns_id" &&
          (Number(addData["sns_type"]) == 2 || Number(addData["sns_type"]) == 3)
            ? true
            : false
        }
        type={dataKey !== "password" ? "text" : "password"}
        id="textFieldId"
        value={value}
        size="small"
        onChange={(e) => setValue(e.target.value)}
        sx={{ width, margin: textFieldMargin }}
      />
      <FormHelperText
        id="serch-name"
        sx={{
          width,
          textAlign: "right",
          marginTop: "-8px",
          height: "25px",
        }}
      >
        {helperText}
      </FormHelperText>
    </Box>
  );
}

interface InputProductOptionProps {
  selectOption: {
    option_name: string;
    outside_form_display: 0 | 1;
    sns_send: 0 | 1;
    required_optional: 0 | 1;
    option_type: 0 | 1 | 2 | 3 | 4;
    option_default_value: string;
    change_value_conf: 0 | 1;
    option_comment: string;
    tel_flg: 0 | 1;
    name_flg: 0 | 1;
    company_name_flg: 0 | 1;
    zip_code_flg: 0 | 1;
    address_flg: 0 | 1;
    space_flg: 0 | 1;
    mail_address_flg: 0 | 1;
    form_tel_flg: 0 | 1;
    multi_text_flg: 0 | 1;
    contract_number_flg: 0 | 1;
    half_width_number_flg: 0 | 1;
    option_select: string[];
  };
  setEelectOption: (select_option: {
    option_name: string;
    outside_form_display: 0 | 1;
    sns_send: 0 | 1;
    required_optional: 0 | 1;
    option_type: 0 | 1 | 2 | 3 | 4;
    option_default_value: string;
    change_value_conf: 0 | 1;
    option_comment: string;
    tel_flg: 0 | 1;
    name_flg: 0 | 1;
    company_name_flg: 0 | 1;
    zip_code_flg: 0 | 1;
    address_flg: 0 | 1;
    space_flg: 0 | 1;
    mail_address_flg: 0 | 1;
    form_tel_flg: 0 | 1;
    multi_text_flg: 0 | 1;
    contract_number_flg: 0 | 1;
    half_width_number_flg: 0 | 1;
    option_select: string[];
  }) => void;
}
function InputProductOption(props: InputProductOptionProps) {
  const { selectOption, setEelectOption } = props;

  const pathname = useAtomValue(AppAtoms.pathname);
  const [selectNameList, setSelectNameList] = useState<string[]>([]);
  return (
    <>
      <Box key={"addBoxOption2_"}>
        <SerchTextField
          width="calc(100% - 10px)"
          key={"serchColumnBubun"}
          label={"質問名"}
          helperText={""}
          value={selectOption["option_name"]}
          setValue={(value) => {
            setEelectOption({
              ...selectOption,
              option_name: value,
            });
          }}
          dataKey={""}
          addData={{}}
        />
      </Box>
      <Box key={"addBoxOption4_"}>
        <Box className="serch-label">質問区分</Box>
        <FormControl
          fullWidth
          sx={{
            marginTop: "10px",
            marginBottom: "20px",
            marginLeft: "5px",
            width: "calc(100% - 10px)",
          }}
        >
          <Select
            labelId="serch-input-label"
            id="serch-input"
            value={selectOption["option_type"]}
            onChange={(e) => {
              setEelectOption({
                ...selectOption,
                option_type: Number(e.target.value) as 0 | 1 | 2 | 3 | 4,
                option_default_value: "",
                change_value_conf: 0,
                tel_flg: 0,
                name_flg: 0,
                company_name_flg: 0,
                zip_code_flg: 0,
                address_flg: 0,
                space_flg: 0,
                mail_address_flg: 0,
                form_tel_flg: 0,
                multi_text_flg: 0,
                contract_number_flg: 0,
                half_width_number_flg: 0,
                option_select: [""],
              });
            }}
            sx={{
              height: "30px",
              textAlign: "end",
              fontSize: "14px",
            }}
          >
            {LIST_POST["option_type"].map((input, i) => {
              return (
                <MenuItem
                  key={"input" + i}
                  value={input.id}
                  sx={{
                    fontSize: "14px",
                    height: input.value === "" ? "14px" : "24px",
                  }}
                >
                  {input.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
      {selectOption["option_type"] === 0 ? (
        <Box key={"addBoxOption99_"}>
          <Box className="serch-label">フラグ設定</Box>
          <FormControl
            fullWidth
            sx={{
              marginTop: "10px",
              marginBottom: "20px",
              marginLeft: "5px",
              width: "calc(100% - 10px)",
            }}
          >
            <Select
              labelId="serch-input-label"
              id="serch-input"
              value={
                selectOption["tel_flg"] == 1
                  ? 1
                  : selectOption["name_flg"] == 1
                    ? 2
                    : selectOption["zip_code_flg"] == 1
                      ? 3
                      : selectOption["address_flg"] == 1
                        ? 4
                        : selectOption["space_flg"] == 1
                          ? 5
                          : selectOption["mail_address_flg"] == 1
                            ? 6
                            : selectOption["form_tel_flg"] == 1
                              ? 7
                              : selectOption["multi_text_flg"] == 1
                                ? 8
                                : selectOption["company_name_flg"] == 1
                                  ? 9
                                  : selectOption["contract_number_flg"] == 1
                                    ? 10
                                    : selectOption["half_width_number_flg"] == 1
                                      ? 11
                                      : 0
              }
              onChange={(e) => {
                if (Number(e.target.value) === 0) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 1) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 1,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 2) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 0,
                    name_flg: 1,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 3) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 1,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 4) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 1,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 5) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 1,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 6) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 1,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 7) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 1,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 8) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 1,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 9) {
                  setEelectOption({
                    ...selectOption,
                    required_optional: 1,
                    outside_form_display: 0,
                    sns_send: 1,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 1,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 10) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 1,
                    half_width_number_flg: 0,
                  });
                } else if (Number(e.target.value) === 11) {
                  setEelectOption({
                    ...selectOption,
                    tel_flg: 0,
                    name_flg: 0,
                    company_name_flg: 0,
                    zip_code_flg: 0,
                    address_flg: 0,
                    space_flg: 0,
                    mail_address_flg: 0,
                    form_tel_flg: 0,
                    multi_text_flg: 0,
                    contract_number_flg: 0,
                    half_width_number_flg: 1,
                  });
                }
              }}
              sx={{
                height: "30px",
                textAlign: "end",
                fontSize: "14px",
              }}
            >
              {pathname === "/entry_form"
                ? (
                    LIST_POST["entry_form_option_flg"] as {
                      id: number;
                      value: string;
                    }[]
                  ).map((input, i) => (
                    <MenuItem
                      key={"input" + i}
                      value={input.id}
                      sx={{
                        fontSize: "14px",
                        height: input.value === "" ? "14px" : "24px",
                      }}
                    >
                      {input.value}
                    </MenuItem>
                  ))
                : pathname === "/outside_entry_form"
                  ? LIST_POST["contract_option_flg"].map((input, i) => {
                      return (
                        <MenuItem
                          key={"input" + i}
                          value={input.id}
                          sx={{
                            fontSize: "14px",
                            height: input.value === "" ? "14px" : "24px",
                          }}
                        >
                          {input.value}
                        </MenuItem>
                      );
                    })
                  : pathname === "/toss_up_form"
                    ? LIST_POST["toss_up_option_flg"].map((input, i) => {
                        return (
                          <MenuItem
                            key={"input" + i}
                            value={input.id}
                            sx={{
                              fontSize: "14px",
                              height: input.value === "" ? "14px" : "24px",
                            }}
                          >
                            {input.value}
                          </MenuItem>
                        );
                      })
                    : null}
            </Select>
          </FormControl>
        </Box>
      ) : selectOption["option_type"] === 1 ||
        selectOption["option_type"] === 2 ? (
        <>
          {selectOption.option_select.map(
            (option_select: string, select_i: number) => {
              return (
                <Box
                  key={"addBoxOptionSelect_" + select_i}
                  sx={{ height: "87px" }}
                >
                  <SerchTextField
                    width="calc(100% - 80px)"
                    key={"serchColumnBubun" + select_i}
                    label={"選択肢 - " + (select_i + 1)}
                    helperText={""}
                    value={option_select}
                    setValue={(value) => {
                      let _option_select = selectOption.option_select.concat();
                      _option_select[select_i] = value;
                      setEelectOption({
                        ...selectOption,
                        option_select: _option_select,
                      });
                    }}
                    dataKey={""}
                    addData={{}}
                  />
                  {selectOption.option_select.length > 1 ? (
                    <Button
                      style={{
                        height: "32px",
                        width: "32px",
                        marginLeft: "calc(100% - 75px)",
                        marginTop: "-110px",
                      }}
                      onClick={(e) => {
                        let _option_select =
                          selectOption.option_select.concat();
                        _option_select = _option_select.filter(
                          (_product_option: string, _select_i: number) =>
                            select_i !== _select_i,
                        );
                        setEelectOption({
                          ...selectOption,
                          option_select: _option_select,
                        });
                      }}
                    >
                      <RemoveCircleOutlineIcon fontSize="medium" />
                    </Button>
                  ) : null}
                </Box>
              );
            },
          )}
          <Box key={"addBoxPriceDataDelete"} sx={{ height: "20px" }}>
            <Button
              style={{
                fontSize: "20px",
                marginTop: "-40px",
                marginLeft: "calc(100% - 140px)",
              }}
              onClick={() => {
                let _option_select = selectOption.option_select.concat();
                _option_select.push("");
                setEelectOption({
                  ...selectOption,
                  option_select: _option_select,
                });
              }}
            >
              <AddCircleOutlineIcon fontSize="medium" />
            </Button>
          </Box>
        </>
      ) : null}
      <Box key={"addBoxOption3_"}>
        <Box className="serch-label">必須フラグ</Box>
        <Checkbox
          checked={selectOption["required_optional"] === 1}
          onChange={(e) => {
            setEelectOption({
              ...selectOption,
              required_optional:
                selectOption["required_optional"] === 1 ? 0 : 1,
            });
          }}
          sx={{
            "& .MuiSvgIcon-root": { fontSize: 18 },
            width: "36px",
          }}
        />
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 36px)",
            marginLeft: "36px",
            marginTop: "-26px",
            marginBottom: "18px",
          }}
        >
          ※必須項目とする場合はチェックしてください。
        </FormHelperText>
      </Box>
      {pathname === "/outside_entry_form" &&
      selectOption["tel_flg"] != 1 &&
      selectOption["name_flg"] != 1 &&
      selectOption["company_name_flg"] != 1 ? (
        <Box key={"addBoxOption4_outside_form"}>
          <Box className="serch-label">外部ETフォームでの表示</Box>
          <FormControl
            fullWidth
            sx={{
              marginTop: "10px",
              marginBottom: "20px",
              marginLeft: "5px",
              width: "calc(100% - 10px)",
            }}
          >
            <Select
              labelId="serch-input-label"
              id="serch-input"
              value={selectOption["outside_form_display"]}
              onChange={(e) => {
                setEelectOption({
                  ...selectOption,
                  outside_form_display: Number(e.target.value) as 0 | 1,
                });
              }}
              sx={{
                height: "30px",
                textAlign: "end",
                fontSize: "14px",
              }}
            >
              {LIST_POST["outside_form_display"].map((input, i) => {
                return (
                  <MenuItem
                    key={"input" + i}
                    value={input.id}
                    sx={{
                      fontSize: "14px",
                      height: input.value === "" ? "14px" : "24px",
                    }}
                  >
                    {input.value}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText
              id="serch-name"
              sx={{
                textAlign: "right",
              }}
            >
              ※外部ETフォームに表示するかどうかを選択できます
            </FormHelperText>
          </FormControl>
        </Box>
      ) : null}
      {selectOption["option_type"] == 0 ? (
        <Box key={"addBoxOption_default"}>
          <SerchTextField
            width="calc(100% - 10px)"
            key={"serchColumnBubun"}
            label={"デフォルト値"}
            helperText={""}
            value={selectOption["option_default_value"]}
            setValue={(value) => {
              if (value === "") {
                setEelectOption({
                  ...selectOption,
                  option_default_value: value,
                  change_value_conf: 0,
                });
              } else {
                setEelectOption({
                  ...selectOption,
                  option_default_value: value,
                });
              }
            }}
            dataKey={""}
            addData={{}}
          />
        </Box>
      ) : null}
      {selectOption["option_type"] == 0 ? (
        <Box key={"addBoxOption4_edit_input"}>
          <Box className="serch-label">入力値の編集</Box>
          <FormControl
            fullWidth
            sx={{
              marginTop: "10px",
              marginBottom: "20px",
              marginLeft: "5px",
              width: "calc(100% - 10px)",
            }}
          >
            <Select
              disabled={selectOption.option_default_value === ""}
              labelId="serch-input-label"
              id="serch-input"
              value={selectOption["change_value_conf"]}
              onChange={(e) => {
                setEelectOption({
                  ...selectOption,
                  change_value_conf: Number(e.target.value) as 0 | 1,
                });
              }}
              sx={{
                height: "30px",
                textAlign: "end",
                fontSize: "14px",
              }}
            >
              {LIST_POST["change_value_conf"].map((input, i) => {
                return (
                  <MenuItem
                    key={"input" + i}
                    value={input.id}
                    sx={{
                      fontSize: "14px",
                      height: input.value === "" ? "14px" : "24px",
                    }}
                  >
                    {input.value}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText
              id="serch-name"
              sx={{
                textAlign: "right",
              }}
            >
              ※デフォルト値が設定されているときのみ、入力値の編集を不可に変更できます。
            </FormHelperText>
          </FormControl>
        </Box>
      ) : null}
      <Box key={"addBoxOption5_"}>
        <SerchTextField
          width="calc(100% - 10px)"
          key={"serchColumnBubun"}
          label={"説明"}
          helperText={""}
          value={selectOption["option_comment"]}
          setValue={(value) => {
            setEelectOption({
              ...selectOption,
              option_comment: value,
            });
          }}
          dataKey={""}
          addData={{}}
        />
      </Box>
      <Box key={"addBoxOption4_sns"}>
        <Box className="serch-label">チャットアプリ連携</Box>
        <FormControl
          fullWidth
          sx={{
            marginTop: "10px",
            marginBottom: "20px",
            marginLeft: "5px",
            width: "calc(100% - 10px)",
          }}
        >
          <Select
            labelId="serch-input-label"
            id="serch-input"
            value={selectOption["sns_send"]}
            onChange={(e) => {
              setEelectOption({
                ...selectOption,
                sns_send: Number(e.target.value) as 0 | 1,
              });
            }}
            sx={{
              height: "30px",
              textAlign: "end",
              fontSize: "14px",
            }}
          >
            {LIST_POST["sns_send"].map((input, i) => {
              return (
                <MenuItem
                  key={"input" + i}
                  value={input.id}
                  sx={{
                    fontSize: "14px",
                    height: input.value === "" ? "14px" : "24px",
                  }}
                >
                  {input.value}
                </MenuItem>
              );
            })}
          </Select>
          <FormHelperText
            id="serch-name"
            sx={{
              textAlign: "right",
              height: "25px",
            }}
          >
            ※チャットアプリ連携した際にエントリー情報として連携するかどうか選択できます。
          </FormHelperText>
        </FormControl>
      </Box>
    </>
  );
}

interface FormOptionsEditModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  backSwCloseModal: () => void;
  editFormsStatus: {
    status:
      | "none"
      | "open"
      | "add"
      | "delete"
      | "success"
      | "loading"
      | "add_error"
      | "delete_error";
    message: string;
    editIDs: number[];
    action: null | 0 | 1;
    delete_option_names: string[];
    select_option: {
      option_name: string;
      outside_form_display: 0 | 1;
      sns_send: 0 | 1;
      required_optional: 0 | 1;
      option_type: 0 | 1 | 2 | 3 | 4;
      option_default_value: string;
      change_value_conf: 0 | 1;
      option_comment: string;
      tel_flg: 0 | 1;
      name_flg: 0 | 1;
      company_name_flg: 0 | 1;
      zip_code_flg: 0 | 1;
      address_flg: 0 | 1;
      space_flg: 0 | 1;
      mail_address_flg: 0 | 1;
      form_tel_flg: 0 | 1;
      multi_text_flg: 0 | 1;
      contract_number_flg: 0 | 1;
      half_width_number_flg: 0 | 1;
      option_select: string[];
    };
  };
  setEditFormsStatus: React.Dispatch<
    React.SetStateAction<{
      status:
        | "none"
        | "open"
        | "add"
        | "delete"
        | "success"
        | "loading"
        | "add_error"
        | "delete_error";
      message: string;
      editIDs: number[];
      delete_option_names: string[];
      action: null | 0 | 1;
      select_option: {
        option_name: string;
        outside_form_display: 0 | 1;
        sns_send: 0 | 1;
        required_optional: 0 | 1;
        option_type: 0 | 1 | 2 | 3 | 4;
        option_default_value: string;
        change_value_conf: 0 | 1;
        option_comment: string;
        tel_flg: 0 | 1;
        name_flg: 0 | 1;
        company_name_flg: 0 | 1;
        zip_code_flg: 0 | 1;
        address_flg: 0 | 1;
        space_flg: 0 | 1;
        mail_address_flg: 0 | 1;
        form_tel_flg: 0 | 1;
        multi_text_flg: 0 | 1;
        contract_number_flg: 0 | 1;
        half_width_number_flg: 0 | 1;
        option_select: string[];
      };
    }>
  >;
  getEditFormDeleteOptionNames: () => void;
  editFormOptionNames: string[];
  postEditFormOption: () => void;
  deleteEditFormOption: () => void;
}

export function FormOptionsEditModal(props: FormOptionsEditModalProps) {
  const {
    onModal,
    swCloseModal,
    backSwCloseModal,
    editFormsStatus,
    setEditFormsStatus,
    getEditFormDeleteOptionNames,
    editFormOptionNames,
    postEditFormOption,
    deleteEditFormOption,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 868 ? "800px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return editFormsStatus.status !== "loading" ? (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} key="ContractAddModalBox" data-testid="form-options-edit-modal">
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          質問一括追加・削除
        </Box>
        {editFormsStatus.status === "open" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 50px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
            key="ContractAddModalBoxProject"
          >
            <Paper elevation={0}>
              <Box
                key="shozai1"
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <FormControl
                  fullWidth
                  sx={{
                    marginTop: "10px",
                    height: "45px",
                    marginLeft: "5px",
                    width: "calc(100% - 10px)",
                  }}
                >
                  <Select
                    labelId="serch-input-label"
                    id="serch-input-option"
                    data-testid="form-options-edit-action-select"
                    sx={{
                      height: "30px",
                      textAlign: "end",
                      fontSize: "14px",
                    }}
                    onChange={(e) => {
                      const action = e.target.value as 0 | 1;
                      setEditFormsStatus({
                        ...editFormsStatus,
                        action,
                      });
                    }}
                  >
                    <MenuItem value={0}>一括追加</MenuItem>
                    <MenuItem value={1}>一括削除</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Paper>
            <Box
              key="editContractOptionBottuns"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <Button
                  data-testid="form-options-edit-next"
                  disabled={editFormsStatus.action === null}
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    if (editFormsStatus.action === 0) {
                      setEditFormsStatus({
                        ...editFormsStatus,
                        status: "add",
                      });
                    } else if (editFormsStatus.action === 1) {
                      getEditFormDeleteOptionNames();
                    }
                  }}
                >
                  <Box
                    className="m-plus-rounded-1c-regular"
                    style={{
                      color:
                        editFormsStatus.action === null
                          ? "rgb(70 70 70)"
                          : undefined,
                    }}
                  >
                    次へ進む
                  </Box>
                </Button>
              </Box>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? "10px" : "5px",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  data-testid="form-options-edit-close"
                  onClick={backSwCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : editFormsStatus.status === "add" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 50px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
            key="ContractAddModalBoxProject"
          >
            <Paper elevation={0}>
              <Box
                key="shozai1"
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <InputProductOption
                  selectOption={editFormsStatus.select_option}
                  setEelectOption={(select_option: any) => {
                    setEditFormsStatus({
                      ...editFormsStatus,
                      select_option: select_option,
                    });
                  }}
                />
              </Box>
            </Paper>
            <Box
              key="editContractOptionBottuns"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <Button
                  data-testid="form-options-edit-add-submit"
                  disabled={editFormsStatus.select_option.option_name === ""}
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={postEditFormOption}
                >
                  <Box
                    className="m-plus-rounded-1c-regular"
                    style={{
                      color:
                        editFormsStatus.select_option.option_name === ""
                          ? "rgb(70 70 70)"
                          : undefined,
                    }}
                  >
                    追加
                  </Box>
                </Button>
              </Box>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? "10px" : "5px",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  data-testid="form-options-edit-add-back"
                  onClick={() =>
                    setEditFormsStatus({
                      ...editFormsStatus,
                      status: "open",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : editFormsStatus.status === "add_error" ? (
          <Typography
            key="ContractAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Box className="shippori-antique-regular">
              {editFormsStatus.message}
            </Box>
            <Box>
              <Button
                style={{
                  marginTop: "30px",
                  marginLeft: windowWidth > 385 ? "15%" : "5px",
                  marginBottom: "-25px",
                  height: "40px",
                  width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                  textTransform: "none",
                }}
                variant="contained"
                data-testid="form-options-edit-add-error-back"
                onClick={() =>
                  setEditFormsStatus({
                    ...editFormsStatus,
                    status: "add",
                  })
                }
              >
                <Box className="m-plus-rounded-1c-regular">戻る</Box>
              </Button>
            </Box>
          </Typography>
        ) : editFormsStatus.status === "delete" ? (
          <Typography
            key="ContractAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                key="shozai1"
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                {editFormOptionNames.map((optionName, i) => {
                  return (
                    <Box
                      key={"deleteOptionName_" + i}
                      sx={{ marginRight: "25px" }}
                    >
                      <Checkbox
                        sx={{
                          "& .MuiSvgIcon-root": { fontSize: 16 },
                          marginTop: "-5px",
                        }}
                        checked={editFormsStatus.delete_option_names.includes(
                          optionName,
                        )}
                        onClick={() => {
                          let delete_option_names =
                            editFormsStatus.delete_option_names.concat();
                          if (
                            editFormsStatus.delete_option_names.includes(
                              optionName,
                            )
                          ) {
                            delete_option_names = delete_option_names.filter(
                              (option_name) => option_name !== optionName,
                            );
                          } else {
                            delete_option_names.push(optionName);
                          }
                          setEditFormsStatus({
                            ...editFormsStatus,
                            delete_option_names,
                          });
                        }}
                      />
                      {optionName}
                    </Box>
                  );
                })}
              </Box>
            </Paper>
            <Box
              key="editContractOptionBottuns"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <Button
                  data-testid="form-options-edit-delete-submit"
                  disabled={editFormsStatus.delete_option_names.length === 0}
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={deleteEditFormOption}
                >
                  <Box
                    className="m-plus-rounded-1c-regular"
                    style={{
                      color:
                        editFormsStatus.delete_option_names.length === 0
                          ? "rgb(70 70 70)"
                          : undefined,
                    }}
                  >
                    削除
                  </Box>
                </Button>
              </Box>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? "10px" : "5px",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  data-testid="form-options-edit-delete-back"
                  onClick={() =>
                    setEditFormsStatus({
                      ...editFormsStatus,
                      status: "open",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : editFormsStatus.status === "delete_error" ? (
          <Typography
            key="ContractAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Box className="shippori-antique-regular">
              {editFormsStatus.message}
            </Box>
            <Box>
              <Button
                style={{
                  marginTop: "30px",
                  marginLeft: windowWidth > 385 ? "15%" : "5px",
                  marginBottom: "-25px",
                  height: "40px",
                  width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                  textTransform: "none",
                }}
                variant="contained"
                data-testid="form-options-edit-delete-error-back"
                onClick={() =>
                  setEditFormsStatus({
                    ...editFormsStatus,
                    status: "open",
                  })
                }
              >
                <Box className="m-plus-rounded-1c-regular">戻る</Box>
              </Button>
            </Box>
          </Typography>
        ) : editFormsStatus.status === "success" ? (
          <Typography
            key="ContractAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Box className="shippori-antique-regular">
              値の編集に成功しました。
            </Box>
            <Box>
              <Button
                style={{
                  marginTop: "30px",
                  marginLeft: windowWidth > 385 ? "15%" : "5px",
                  marginBottom: "-25px",
                  height: "40px",
                  width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                  textTransform: "none",
                }}
                data-testid="form-options-edit-success-close"
                variant="contained"
                onClick={swCloseModal}
              >
                <Box className="m-plus-rounded-1c-regular">閉じる</Box>
              </Button>
            </Box>
          </Typography>
        ) : null}
      </Box>
    </Modal>
  ) : null;
}
